import request from '../../../helpers/request';

const deleteRoomImage = async (imageId, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      description: {
        ...room.description,
        attachments: room.description.attachments.filter(
          (attachment) => attachment.id !== imageId
        ),
      },
    },
    'При удалении фото произошла ошибка'
  );
};

export default deleteRoomImage;
